import { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import ConfirmContext from "../utils/confirmContext";
function ProtectedRoute({ component: Component, ...rest }) {
  const isAuthenticated = localStorage.getItem("isAuthenticated");
  const thisConfirmContext = useContext(ConfirmContext);

  return (
    <Route
      {...rest}
      render={(props) => {
        const currentPath = props.location.pathname + props.location.search;

        if (!isAuthenticated) {
          // تشغيل البوب أب داخل useEffect وليس هنا
          setTimeout(() => {
            thisConfirmContext?.onShowRegistrationPup(true);
          }, 0);

          return (
            <Redirect to={`/?redirect=${encodeURIComponent(currentPath)}`} />
          );
        }

        return <Component {...props} />;
      }}
    />
  );
}

export default ProtectedRoute;
